import { getAllowedRoles } from '@/../config/userRoles';

export default [
  {
    path: '',
    name: 'user-management',
    component: () => import('@/components/user-management/UserManagement'),
    meta: {
      title: 'User management',
      allowedUserRoles: getAllowedRoles('userManagement'),
    },
  },
  {
    path: 'activity-log',
    name: 'user-management-activity-log',
    component: () => import('@/components/user-management/UserManagementActivityLog'),
    meta: {
      title: 'Activity log',
      allowedUserRoles: getAllowedRoles('userManagement'),
    },
  },
];
